<template>
    <div>
        <!-- <el-steps :active="1" finish-status="success" align-center>
            <el-step title="改表,修复提交"></el-step>
            <el-step title="特约资深行家划价建议"></el-step>
            <el-step title="打款"></el-step>
            <el-step title="特约技术工作"></el-step>
            <el-step title="验收交付"></el-step>
            <el-step title="交易完成"></el-step>
        </el-steps> -->

        <img src="./img/step.png" alt="" class="stepImg">

        <el-row>
            <el-button type="primary" size="small" @click="add_dialog.show = true">新增改表修复申请</el-button>
        </el-row>

        <el-row style="margin:20px 0">
            <el-select v-model="queryParams.type" placeholder="请选择彩种" size="small" style="margin-right:10px">
                <el-option label="双色球" value="00"></el-option>
                <el-option label="大乐透" value="01"></el-option>
                <el-option label="福彩3D" value="02"></el-option>
                <el-option label="排列三" value="03"></el-option>
            </el-select>
            <el-select v-model="queryParams.excleType" placeholder="请选择申请类型" size="small">
                <el-option label="闲置" value="0"></el-option>
                <el-option label="定制" value="1"></el-option>
            </el-select>
            <el-button type="primary" size="small" @click="getList" style="margin-left:10px">查询</el-button>
        </el-row>

        <div v-loading="tableLoading">
            <el-empty v-if="tableData.length === 0" description="暂无数据"></el-empty>

            <el-table :data="tableData" v-else>
                <el-table-column label="彩种">
                    <template slot-scope="scope">
                        {{getMapping(scope.row.type,'lotteryType')}}
                    </template>
                </el-table-column>
                <el-table-column label="闲置/定制">
                    <template slot-scope="scope">
                        {{getMapping(scope.row.excleType,'excleType')}}
                    </template>
                </el-table-column>
                <el-table-column label="文件名">
                    <template slot-scope="scope">
                        <div class="fileName" :title="getMapping(scope.row.oldExcel,'fileName')">
                            {{getMapping(scope.row.oldExcel,'fileName')}}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="议价">
                    <template slot-scope="scope">
                        {{scope.row.suggestsPrice}}
                    </template>
                </el-table-column>
                <el-table-column label="打款">
                    <template slot-scope="scope">
                        {{scope.row.price}}
                    </template>
                </el-table-column>
                <el-table-column label="修改文件">
                    <template slot-scope="scope">
                        <div @click="downFile(scope.row)" style="color:blue;cursor: pointer;">
                            {{getMapping(scope.row.newExcel,'fileName')}}
                        </div>
                    </template>
                </el-table-column>
				<el-table-column label="时间">
                    <template slot-scope="scope">
						{{ convertToYearMonthDayHourMinuteSecond(scope.row.createTime) }}
                    </template>
                </el-table-column>

                <el-table-column label="操作" width="180">
                    <template slot-scope="scope">
                        <div v-if="scope.row.node == 2" v-loading="scope.row.payBtnLoading">

                            <el-button type="text" style="color:red" @click="makeAPayment('wxpay', scope.row)">微信打款</el-button>
                            <br>
                            <el-button type="text" style="color:#000" @click="makeAPayment('alipay',scope.row)">支付宝打款</el-button>
                            <br>
                            <el-button type="text" style="color:blue" @click="makeAPayment('balancepay',scope.row)">余额打款</el-button>

                        </div>
                        <el-button v-else type="text" @click="editItem(scope.row)">{{getMapping(scope.row.node,'step')}}</el-button>
                    </template>
                </el-table-column>
            </el-table>

            <div class="pagin">
                <el-pagination background layout="prev, pager, next" :page-size="queryParams.pageSize" :total="queryParams.total" :current-page.sync="queryParams.pageNum" @current-change="getList">
                </el-pagination>
            </div>

        </div>

        <el-dialog title="添加" :visible.sync="add_dialog.show" :close-on-click-modal="false">
            <el-form>
                <h3>一,申请</h3>
                <el-form-item label="申请彩种">
                    <el-select v-model="form.type" placeholder="请选择彩种">
                        <el-option v-for="(item, index) in lotteryArr" :key="index" :label="item.label" :value="item.value"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="申请类型">
                    <el-select v-model="form.excleType" placeholder="闲置/定制">
                        <el-option v-for="(item, index) in excleTypeArr" :key="index" :label="item.label" :value="item.value"></el-option>
                    </el-select>
                </el-form-item>

                <h3>二,上传该彩种excel表以及修改或者修复需求说明(附在excel里说明)</h3>
                <p v-if="form.oldExcel">当前文件：{{getMapping(form.oldExcel,'fileName')}} <span style="color:red;cursor: pointer;" @click="form.oldExcel=''">删除</span> </p>
                <el-form-item v-else label="上传文件">
                    <el-upload class="upload-demo" drag action :auto-upload="false" :limit="1" :on-change="uploadChange" v-loading="uploadLoading">
                        <i class="el-icon-upload"></i>
                        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                    </el-upload>
                </el-form-item>

                <el-form-item>
                    <el-button type="primary" size="small" @click="confirmSave" :loading="confirmLoading">确定</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>

        <el-dialog title="支付" :visible.sync="showPayCode" :close-on-click-modal="false">
            <div style="text-align:center">
                <p>请使用 <b>{{payCodeMessage}}</b> 扫码支付</p>
                <p style="color:red">扫码支付成功后, 若状态未更新, 请刷新下页面</p>
                <div v-if="showPayCode" ref="qrcode" style="margin: auto; width: fit-content; "></div>
            </div>
        </el-dialog>

        <el-dialog title="验收交付" :visible.sync="acceptance.show" :close-on-click-modal="false">
            <el-form>
                <el-form-item>
                    <el-radio-group v-model="acceptance.radio">
                        <el-radio label="满意"></el-radio>
                        <el-radio label="不满意"></el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item v-if="acceptance.radio === '不满意'">
                    <el-input v-model="acceptance.message" />
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="funAcceptance">保存</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>

    </div>
</template>

<script>
import QRCode from 'qrcodejs2';
import { queryUuIdInfo, createOrder } from "@/api/common";
import a from '@/components/a.vue';
export default {
    components: { a },

	computed:{
		convertToYearMonthDayHourMinuteSecond() {
			return function(isoString){
				const date = new Date(isoString); // 将 ISO 8601 格式字符串转换为 Date 对象
				const year = date.getFullYear(); // 获取年份
				const month = String(date.getMonth() + 1).padStart(2, '0'); // 获取月份，加 1 是因为 getMonth() 返回的月份是从 0 开始的，padStart 用于补全两位数字
				const day = String(date.getDate()).padStart(2, '0'); // 获取日期
				const hour = String(date.getHours()).padStart(2, '0'); // 获取小时
				const minute = String(date.getMinutes()).padStart(2, '0'); // 获取分钟
				const second = String(date.getSeconds()).padStart(2, '0'); // 获取秒
	
				return `${year}-${month}-${day} ${hour}:${minute}:${second}`; // 按照年月日时分秒的格式拼接字符串
			}
		}
	},

    data () {
        return {
            acceptance: {
                show: false,
                radio: '满意',
                message: '',
				item:{}
            },
            lotteryArr: [
                { value: '00', label: '双色球' },
                { value: '01', label: '大乐透' },
                { value: '02', label: '福彩3D' },
                { value: '03', label: '排列三' },
            ],
            excleTypeArr: [
                { value: '0', label: '闲置' },
                { value: '1', label: '定制' },
            ],
            add_dialog: {
                show: false,
            },

            form: {
                type: '00',
                excleType: '0',
                node: '1',
                oldExcel: '',
            },

            queryParams: {
                type: '00',
                excleType: '0',
                userId: '',

                pageNum: 1,
                pageSize: 10,
                total: 0,
            },

            tableData: [],
            tableLoading: false,

            uploadLoading: false,

            confirmLoading: false,

            showPayCode: false,
            payCodeMessage: '',

            socket: null, // Socket连接对象
            ws: {},

            payItem: {},

        }
    },
    created () {
        this.queryParams.userId = this.vuex_userInfo.userId
    },
    mounted () {
        this.getList()
    },
    methods: {

        downFile (item) {
            let a = document.createElement('a')
            a.href = process.env.VUE_APP_BASE_API + item.newExcel,
                a.download = this.getMapping(item.newExcel, 'fileName')
            a.click()
        },

        funSocket () {
            return new Promise(resolve => {
                let wsUrl = `${process.env.VUE_APP_BASE_WS}/stage-api/pay-websocket/${this.vuex_token}?userId=${this.vuex_userInfo.userId}&businessType=pay`
                this.ws = new WebSocket(wsUrl)
                this.ws.onopen = _ => {
                    console.log("WebSocket is open now.")
                    resolve()
                };

                this.ws.onmessage = event => {
                    console.log("Message from server ", event.data);
                    let { code, msg } = JSON.parse(event.data)
                    if (msg == '支付成功') {
                        this.showPayCode = false
                        this.$alert(msg, '提示', { confirmButtonText: '确定', });

                        // 闲置定制表修改进度修改
                        this.$http.post('/stage-api/technicianIdle/updateTechnicianIdle', {
                            id: this.payItem.params.item_id,
                            suggestsPrice: this.payItem.money,
                            price: this.payItem.money,
                            node: 3,
                            // status
                            // remark
                            // newExcle
                            // acceptance

                        }).then(res => {
                            this.$message.success('成功');
                            this.getList()
                        })


                    }
                }

            })
        },

        // 打款
        makeAPayment (payType, item) {
            item.payBtnLoading = true;

            this.funSocket().then(res => {

                // 查看商品信息
                this.$http.post('/stage-api/technicianIdle/queryTechnicianIdleByRecordId', {
                    id: item.id,
                }).then(res => {
                    let { price, productId, specsId, technicianIdleId } = res.data;

                    let params = {
                        money: price,									//支付金额
                        payType,					 //选择				//支付类型 : wxpay:微信支付;alipay:阿里支付;balancepay:余额支付
                        productId,										//商品id
                        productModel: '1',										//商品模块:商品所属模块;0:预测缩水单商品;1:excel专场商品;2:缩水软件特区商品;3:个人中心充值;4:个人中心提现5:投注站帮扶中心
                        quantity: '1',											//商品数量
                        title: new Date().getTime(),   							//商品标题
                        productSpecsId: specsId,									//商品规格ID
                        productAuthor: item.userId,										//商家ID
                        uuid: new Date().getTime(),
                        params: {
                            item_id: item.id,
                        }
                    }

                    this.payItem = params

                    this.fun_createOrder(params, item)

                })
            })
        },

		// 验收
		funAcceptance(){
			if(this.acceptance.radio == '满意'){ this.acceptance.message = '' }
			let {radio,message,item} = this.acceptance

			let params = {
				price: item.price,
				id: item.id,
				suggestsPrice: item.suggestsPrice,
				node: item.node * 1 + 1,
				acceptance: message ||  radio,
			}
			
			this.$http.post('/stage-api/technicianIdle/updateTechnicianIdle', params).then(res => {
				this.$message.success('成功');
				this.getList()
				this.acceptance.show = false
			})
		},

        editItem (item) {
            console.log('item', JSON.parse(JSON.stringify(item)));
            // 验收
            if (item.node == 4) {

                this.acceptance.show = true
				this.acceptance.item = item

            }
        },

        fun_createOrder (payParams, item) {
			console.log('payParams',payParams);
			console.log('item',JSON.parse(JSON.stringify(item)));
            return new Promise((resolve, reject) => {
                // 创建订单
                createOrder(payParams).then(res => {
                    if (res.code == 200) {

                        if (['wxpay', 'alipay'].includes(payParams.payType)) {
                            this.showPayCode = true;
                            this.payCodeMessage = res.data.payType.displayName;
                            console.log('createOrder res', res);
                            this.$nextTick(() => {
                                new QRCode(this.$refs.qrcode, {
                                    text: res.data.codeUrl,
                                    width: 128 * 2,
                                    height: 128 * 2
                                });
                            });
                        }

                        if (payParams.payType == 'balancepay') {
                            this.$message.success('余额支付成功')

							// 闲置定制表修改进度修改
							this.$http.post('/stage-api/technicianIdle/updateTechnicianIdle', {
								id: this.payItem.params.item_id,
								suggestsPrice: this.payItem.money,
								price: this.payItem.money,
								node: 3,
							}).then(res => {
								this.$message.success('成功');
								this.getList()
							})
                        }
                        resolve()
                    } else {
                        this.$message.error(res.msg)
                    }
                }).finally(_ => {
                    item.payBtnLoading = false
                })
            })
        },


        getMapping (value, type) {
            if (value) {
                if (type === 'lotteryType') {
                    return value === '00' ? '双色球' : value === '01' ? '大乐透' : value === '02' ? '福彩3D' : value === '03' ? '排列三' : ''
                }
                if (type === 'excleType') {
                    return value === '0' ? '闲置' : value === '1' ? '定制' : ''
                }
                if (type === 'step') {
                    return value === '1' ? '等待后台修表人员处理' : value === '2' ? '打款' : value === '3' ? '特约技术工作中' : value === '4' ? '验收交付' : value === '5' ? '交易完成' : ''
                }
                if (type === 'fileName') {
                    let findUrlIndex = value.lastIndexOf('/');
                    return value ? value.substr(findUrlIndex + 1) : ''
                }
            }
        },
        getList () {
            this.tableLoading = true
            this.tableData = []

            let params = this.$utils.getParamByJson(this.queryParams);
            this.$http.get('/stage-api/technicianIdle/list?' + params).then(res => {
                console.log('getList', JSON.parse(JSON.stringify(res)))
                this.tableLoading = false
                res.rows.forEach(item => item.payBtnLoading = false)
                this.tableData = res.rows
                this.queryParams.total = res.total
            }).catch(err => {
                this.tableLoading = false
            })
        },
        async uploadChange (file,) {
            try {
                this.uploadLoading = true
                let params = this.$utils.getParamByJson({ bizId: await queryUuIdInfo(), fileType: "excel_release_txt", number: 1, })
                this.$utils.upLoadFile('?' + params, { file: file.raw }).then((res) => {
                    this.form.oldExcel = res.data.urls
                    this.uploadLoading = false
                });
            } catch (err) {
                console.log('err', err);
                this.uploadLoading = false
            }
        },
        confirmSave () {
            if (this.form.oldExcel == '') {
                return this.$message.error('请上传文件')
            }
            this.confirmLoading = true
            this.$http.post('/stage-api/technicianIdle/repplyTechnicianIdle', this.form).then(res => {
                this.$message.success('保存成功')
                this.add_dialog.show = false
                this.getList()
                this.resetForm()
            })
                .finally(fin => {
                    this.confirmLoading = false
                })

        },

        resetForm () {
            this.form = {
                type: '00',
                excleType: '0',
                node: '1',
                oldExcel: '',
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.stepImg {
    max-width: 100%;
    width: 1200px;
    margin-bottom: 20px;
}
.pagin {
    width: fit-content;
    margin: 20px auto;
}
.fileName {
    white-space: nowrap;
    text-overflow: ellipsis;
    width: 100%;
    overflow: hidden;
}
</style>